/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/',
                name: 'dashboard',
                component: () => import('./views/Dashboard.vue'),
                meta : {
                  requiresAuth: true,
                  role: ['Admin','Artisan','User']
                }
              },
              {
                path: '/artisans',
                name: 'artisans',
                component: () => import('./views/artisans/ListView.vue'),
                meta : {
                  requiresAuth: true,
                  role: ['Admin','User']
                }
              },
              {
                path: '/clients',
                name: 'clients',
                component: () => import('./views/clients/ListView.vue'),
                meta : {
                  requiresAuth: true,
                  role: ['Admin','User']
                }
              },
              {
                path: '/interventions',
                name: 'interventions',
                component: () => import('./views/interventions/ListView.vue'),
                meta : {
                  requiresAuth: true,
                  role: ['Admin','User']
                }
              },
              {
                path: '/mes_interventions',
                name: 'mes_interventions',
                component: () => import('./views/interventions/ListViewByArtisan.vue'),
                meta : {
                  requiresAuth: true,
                  role: ['Artisan']
                }
              },
              {
                path: '/intervention/:id?',
                name: 'intervention',
                component: () => import('./views/interventions/workflow_intervention.vue'),
                meta : {
                  requiresAuth: true,
                  role: ['Admin','User']
                },
                props: true
              },
              {
                path: '/mon-intervention/:id?',
                name: '/mon-intervention',
                component: () => import('./views/interventions/workflow_intervention_by_artisan.vue'),
                meta : {
                  requiresAuth: true,
                  role: ['Artisan']
                },
                props: true
              },
              {
                path: '/agenda',
                name: 'agenda',
                component: () => import('./views/agenda/index.vue'),
                meta : {
                  requiresAuth: true,
                  role: ['Admin','User']
                }
              },
              {
                path: '/mon-agenda',
                name: 'mon-agenda',
                component: () => import('./views/agenda/index_by_artisan.vue'),
                meta : {
                  requiresAuth: true,
                  role: ['Artisan']
                }
              },
              {
                path: '/factures',
                name: 'factures',
                component: () => import('./views/factures/ListView.vue'),
                meta : {
                  requiresAuth: true,
                  role: ['Admin','User']
                }
              },
              {
                path: '/auto-factures',
                name: 'auto-factures',
                component: () => import('./views/AutoInvoices/invoices.vue')
              },
              {
                path: '/mes-auto-factures',
                name: 'mes-auto-factures',
                component: () => import('./views/AutoInvoices/invoices_by_artisan.vue'),
                meta : {
                  requiresAuth: true,
                  role: ['Artisan']
                }
              },
              {
                path: '/auto-facture/:id?',
                name: 'auto-facture',
                component: () => import('./views/AutoInvoices/invoice.vue'),
                props: true
              },
              {
                path: '/devis',
                name: 'devis',
                component: () => import('./views/devis/ListView.vue'),
                meta : {
                  requiresAuth: true,
                  role: ['Admin','User']
                }
              },
              {
                path: '/produits',
                name: 'produits',
                component: () => import('./views/products/index.vue'),
                meta : {
                  requiresAuth: true,
                  role: ['Admin','User']
                }
              },

              {
                path: '/historiques',
                name: 'historiques',
                component: () => import('./views/historiques/ListView.vue'),
                meta : {
                  requiresAuth: true,
                  role: ['Admin','User']
                }
              },

            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/login',
                name: 'login',
                component: () => import('./views/login/Login.vue'),
                meta : {
                  role: ['Artisan','Admin','User']
                }
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue'),
                meta : {
                  role: ['Artisan','Admin','User']
                }
              },
              {
                path: '/paiement/:id',
                name: 'paiement',
                component: () => import('@/views/paiements/index.vue'),
                props: true
              }
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

router.beforeEach((to, from, next) => {
  
  const token = Vue.$cookies.get('token');
  const role = Vue.$cookies.get('role');

  // if (to.matched.some(record => record.meta.requiresAuth)) {
  if (to.meta.requiresAuth == true) {
    if(role !=null){
      if(!to.meta.role.includes(role)){
          return next({path: '/pages/error-404'});
      }
    }

    if (!!token) {
      to; from;
      return next();
    } else {
      next({path: '/login'});
    }

    next({path: '/login'});

  } else {
    next();
  }

})

export default router
